import reducer from './reducer';
import saga from './saga';
export default function getModule() {
    return {
        id: 'socialLoginModule',
        reducerMap: reducer,
        sagas: [saga],
    };
}
//# sourceMappingURL=module.js.map